/**
 * Add any extra packages that the patterns documentation requires here.
 * Any packages listed here need to be installed in design-system/website package manually.
 *
 * ================================================ IMPORTANT NOTE ================================================
 *
 * Packages with default exports (for example use-resize-observer) must be listed as an object with 2 properties:
 * package: The package name
 * importName: The name used to import and use the module in code samples. This name must be unique to avoid naming collisions.
 *
 * For example this item   { package: 'use-resize-observer', importName: 'useResizeObserver', } will be imported in the
 * docs site and playground as import useResizeObserver from 'use-resize-observer'.
 *
 * You can also resolve conflicting namespace here by providing an import prefix for a package.
 * For example both @balance-web/forms and react-hook-forms export useForm which creates a naming clash.
 * Below we've told the compiler to prefix all exports from react-hook-form with ReactHookForm.
 * So useForm from react-hook-form is expored as ReactHookForm_useForm which is how it should be used in code samples.
 * ================================================ IMPORTANT NOTE ================================================
 */

const packages = [
  'lodash',
  '@faker-js/faker',
  {
    package: 'use-resize-observer',
    importName: 'useResizeObserver',
  },
  {
    package: 'react-hook-form',
    prefixImports: 'ReactHookForm',
  },
];

module.exports = { packages };
